import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

// Pad de firma con pointer events: funciona con dedo (móvil), pluma y mouse.
export const FirmaPad = ({ onChange, testid = "firma-pad" }) => {
  const ref = useRef(null);
  const dibujando = useRef(false);
  const [vacio, setVacio] = useState(true);
  useEffect(() => {
    const cv = ref.current, r = window.devicePixelRatio || 1, w = cv.offsetWidth, h = cv.offsetHeight;
    cv.width = w * r; cv.height = h * r;
    const ctx = cv.getContext("2d");
    ctx.scale(r, r); ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#111";
  }, []);
  const pos = (e) => { const b = ref.current.getBoundingClientRect(); return [e.clientX - b.left, e.clientY - b.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); dibujando.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!dibujando.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); };
  const up = () => { if (!dibujando.current) return; dibujando.current = false; setVacio(false); onChange(ref.current.toDataURL("image/png")); };
  const limpiar = () => { const cv = ref.current; cv.getContext("2d").clearRect(0, 0, cv.width, cv.height); setVacio(true); onChange(""); };
  return (
    <div className="relative">
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid={testid}
        className="h-44 w-full touch-none rounded-2xl border-2 border-dashed border-[#CFC8BC] bg-white" style={{ touchAction: "none" }} />
      {vacio && <p className="pointer-events-none absolute inset-0 grid place-items-center text-sm text-[#A8A196]">Firma aquí con tu dedo o mouse</p>}
      <button type="button" onClick={limpiar} className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-[#F2F0EC] px-3 py-1 text-xs font-semibold text-[#5C5850] transition-colors hover:bg-[#E2DDD5]" data-testid={`${testid}-limpiar`}><Eraser size={12} />Borrar</button>
    </div>
  );
};
